import { render, staticRenderFns } from "./Mandatos.vue?vue&type=template&id=58993ef8"
import script from "./Mandatos.vue?vue&type=script&lang=js"
export * from "./Mandatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports